import { ClimateRegion } from './types';

// DOE/IECC climate zones collapsed to five buckets, assigned per state by
// population-weighted center (e.g. CA counts as MARINE for its coastal
// majority). Sub-state refinement lives in climateRegionOverrides.ts, which
// wins over these defaults in resolveRegion.
export const CLIMATE_REGION_BY_STATE: Record<string, ClimateRegion> = {
  AK: 'COLD',
  AL: 'HOT_HUMID',
  AR: 'MIXED',
  AZ: 'HOT_DRY',
  CA: 'MARINE',
  CO: 'COLD',
  CT: 'COLD',
  DC: 'MIXED',
  DE: 'MIXED',
  FL: 'HOT_HUMID',
  GA: 'HOT_HUMID',
  HI: 'HOT_HUMID',
  IA: 'COLD',
  ID: 'COLD',
  IL: 'MIXED',
  IN: 'MIXED',
  KS: 'MIXED',
  KY: 'MIXED',
  LA: 'HOT_HUMID',
  MA: 'COLD',
  MD: 'MIXED',
  ME: 'COLD',
  MI: 'COLD',
  MN: 'COLD',
  MO: 'MIXED',
  MS: 'HOT_HUMID',
  MT: 'COLD',
  NC: 'MIXED',
  ND: 'COLD',
  NE: 'COLD',
  NH: 'COLD',
  NJ: 'MIXED',
  NM: 'HOT_DRY',
  NV: 'HOT_DRY',
  NY: 'COLD',
  OH: 'MIXED',
  OK: 'MIXED',
  OR: 'MARINE',
  PA: 'MIXED',
  RI: 'COLD',
  SC: 'HOT_HUMID',
  SD: 'COLD',
  TN: 'MIXED',
  TX: 'HOT_HUMID',
  UT: 'COLD',
  VA: 'MIXED',
  VT: 'COLD',
  WA: 'MARINE',
  WI: 'COLD',
  WV: 'MIXED',
  WY: 'COLD',
};
